export default "__VITE_PUBLIC_ASSET__598ba94e__"